import axios from "axios"
import { getCurrentUserID } from '@/utils/GetStateInStore'

const api = process.env.VUE_APP_API_URL || 'https://tracker.aopa.ru/api/lk/';

axios.defaults.withCredentials = true

class API {
  async loginUserWithPass(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return await axios.post(`${api}login${queryString}`, data)
    .then((response) => {
      return response.data
    })
  }

  async resetPassword(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return await axios.post(`${api}restorePassword${queryString}`, data)
    .then((response) => {
      return response.data
    })
  }

  async sendConfirmEmailLetter(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return await axios.post(`${api}sendConfirmEmailLetter${queryString}`, data)
    .then((response) => {
      return response.data
    })
  }

  async registrationUser(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return await axios.post(`${api}registerUser${queryString}`, data)
    .then((response) => {
      return response.data
    })
  }

  async loginWithCookie() {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return await axios.get(`${api}get_user_info${queryString}`, { withCredentials: true })
    //return await axios.get(`/test/get_user_info.json${queryString}`, { withCredentials: true }) // test json
    .then((response) => {
      return response.data
    })
  }

  async saveInfo(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return axios(`${api}saveInfo${queryString}`, {
      method: "post",
      data: data,
      withCredentials: true
    })
    .then((response) => {
      return response.data
    })
  }

  async savePhoto(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return axios(`${api}savePhoto${queryString}`, {
      method: "post",
      data: data,
      withCredentials: true
    })
    .then((response) => {
      return response.data
    })
  }

  payEntry(data) { 
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return axios(`${api}requestMembership${queryString}`, {
      method: "post",
      data: data,
      withCredentials: true,
    })
    .then((response) => {
      return response.data
    })
  }

  payForMembership(data) { // API для оплаты членства:
    return axios(`${api}payForMembership`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  registerPaymentQR(data) { // API для оплаты членства через QR-код
    return axios(`${api}registerPaymentQR`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  disableAutoprolongation(data) { // отключение автопродления членства
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''

    return axios(`${api}disableAutoprolongation${queryString}`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  savePassportScan(data) {
    return axios(`${api}savePassportScan`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  saveRequestScan(data) {
    return axios(`${api}saveRequestScan`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  sendPhoneVerifyCode(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''
    return axios(`${api}sendPhoneVerifyCode${queryString}`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  confirmPhoneByCode(data) {
    const queryString = (getCurrentUserID()) ? "?current_user=" + getCurrentUserID() : ''
    return axios(`${api}confirmPhoneNumberByCode${queryString}`, {
      method: "post",
      data: data,
      withCredentials: true,
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    })
    .then((response) => {
      return response.data
    })
  }

  // async MembershipPayment(data) {
  //   return await axios.post(`${api}`, data)
  //   .then((response) => {
  //     return response.data
  //   })
  // }

  /*async confirmEmail(data) {
    return await axios.post(`${api}confirmEmail`, data)
    .then((response) => {
      return response.data
    })
  }*/

 }

export default API

export function getUserErrorMessage(err) {
    if (   err
        && err.response
        && err.response.headers
        && err.response.headers['content-type']
        && err.response.headers['content-type'].match(/application\/json/)
        && err.response.data
        && err.response.data.errorMessage
    ) {
        return err.response.data.errorMessage;
    }

    return null;
}
